// Datos reales del negocio — Pastelería Panadería Rawan.
export const CONTACTO = {
  direccion1: "Carrer del Pintor Guàrdia, 11, bjs",
  direccion2: "08560 Manlleu, Barcelona, España",
  telefono: "659 10 97 98",
  telefonoHref: "tel:+34659109798",
  email: "Fornpastisseriarawan@gmail.com",
  emailHref: "mailto:Fornpastisseriarawan@gmail.com",
  comoLlegarUrl:
    "https://www.google.com/maps/dir/?api=1&destination=Carrer%20del%20Pintor%20Gu%C3%A0rdia%2C%2011%2C%2008560%20Manlleu%2C%20Barcelona",
  mapEmbedUrl:
    "https://maps.google.com/maps?q=Carrer%20del%20Pintor%20Gu%C3%A0rdia%2C%2011%2C%2008560%20Manlleu%2C%20Barcelona&t=&z=17&ie=UTF8&iwloc=&output=embed",
};

// Horario real del negocio.
export const HORARIO = [
  { dias: "Martes a Viernes", franjas: "8:30 – 14:30 · 16:30 – 21:00" },
  { dias: "Sábados", franjas: "8:30 – 15:00 · 16:30 – 21:00" },
  { dias: "Domingos", franjas: "8:30 – 14:30 · 16:30 – 21:00" },
  { dias: "Lunes", franjas: "Cerrado" },
];

export const NAV_LINKS = [
  { label: "Inicio", href: "#inicio" },
  { label: "Productos", href: "#productos" },
  { label: "Encargos", href: "#encargos" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Ubicación", href: "#ubicacion" },
];

export const MARQUEE_ITEMS = [
  "Panes artesanales",
  "Bollería & Croissants",
  "Pastas tradicionales & árabes",
  "Pastelería fina & Tartas personalizadas",
  "Productos salados",
  "Sushi",
  "Trampantojos",
  "Encargos para bodas y celebraciones",
];

// Enlaces sociales.
export const SOCIAL = {
  instagram: "https://www.instagram.com/pastisseria_rawan_",
  whatsapp: "https://wa.me/34659109798",
};

export const IMAGENES = {
  hero: "/img/hero-croissant.webp",
  artesania:
    "https://images.unsplash.com/photo-1537734796389-e1fc293cf856?q=80&w=1400&auto=format&fit=crop",
  artesaniaDetalle:
    "https://images.unsplash.com/photo-1599819055803-717bba43890f?q=80&w=800&auto=format&fit=crop",
};

export const PRODUCTOS = [
  {
    id: "panes",
    numero: "01",
    titulo: "Panes artesanales",
    descripcion:
      "Panes de elaboración diaria, trabajados a mano con procesos tradicionales e ingredientes seleccionados.",
    imagen: "/img/panes-miga.webp",
    imagenes: ["/img/panes-baguettes.webp", "/img/hero-pan.webp"],
  },
  {
    id: "salados",
    numero: "02",
    titulo: "Productos salados",
    descripcion:
      "Especialidades saladas y bocados artesanales, perfectos para compartir en cualquier ocasión.",
    imagen: "/img/salado-marisco.webp",
  },
  {
    id: "arabes",
    numero: "03",
    titulo: "Pastas tradicionales & árabes",
    descripcion:
      "Nuestras pastas más características: recetas tradicionales y árabes elaboradas con esmero.",
    imagen: "/img/pastas-arabes.webp",
  },
  {
    id: "pasteleria",
    numero: "04",
    titulo: "Pastelería fina & Tartas personalizadas",
    descripcion:
      "Creaciones a medida para celebraciones y momentos especiales, diseñadas contigo.",
    imagen: "/img/pasteleria-fina.webp",
  },
  {
    id: "bolleria",
    numero: "05",
    titulo: "Bollería & Croissants",
    descripcion:
      "Hojaldres y bollería horneados cada día, crujientes por fuera y tiernos por dentro.",
    imagen: "/img/bolleria-croissants.webp",
  },
  {
    id: "sushi",
    numero: "06",
    titulo: "Sushi",
    descripcion:
      "Piezas y bandejas de sushi elaboradas al detalle, una apuesta distinta dentro del obrador.",
    imagen: "/img/sushi.webp",
  },
  {
    id: "trampantojos",
    numero: "07",
    titulo: "Trampantojos (Trompe-l'œil)",
    descripcion:
      "Dulces que engañan a la vista: creaciones con forma de fruta que sorprenden por fuera y deleitan por dentro.",
    imagen: "/img/trampantojo-mango.jpg",
    imagenes: ["/img/trampantojo-manzana.webp", "/img/trampantojo-fresa.webp"],
  },
];

// Encargos para bodas y celebraciones.
export const ENCARGOS = {
  imagen: "/img/tarta-boda-2.webp",
  imagenesSecundarias: [
    {
      src: "/img/tarta-boda.webp",
      alt: "Tarta de boda personalizada con flores elaborada por Rawan",
    },
    {
      src: "/img/encargo-tarta-vintage.webp",
      alt: "Tarta personalizada de estilo vintage elaborada por Rawan",
    },
    {
      src: "/img/encargo-pastilla.webp",
      alt: "Pastila dulce decorada con almendras y pétalos de rosa, elaborada por encargo por Rawan",
    },
    {
      src: "/img/encargo-salados.webp",
      alt: "Bandeja de mini salados preparada por encargo por Rawan",
    },
  ],
  nota: "Preparación de comida y repostería por encargo. No ofrecemos servicio de catering.",
  bloques: [
    {
      icon: "utensils",
      titulo: "Especialidades y salados por encargo",
      items: [
        "Pastila marroquí",
        "Briwats",
        "Cordero al horno",
        "Pollo al horno",
        "Amplia variedad de mini salados",
      ],
    },
    {
      icon: "cake",
      titulo: "Tartas de boda y personalizadas",
      descripcion:
        "Diseños a medida y tartas artesanales para todo tipo de celebraciones.",
    },
    {
      icon: "gift",
      titulo: "Surtidos de postres",
      descripcion:
        "Bandejas y selecciones de repostería y dulces para eventos.",
    },
  ],
};

export const VALORES = [
  {
    icon: "hand",
    titulo: "Elaboración artesanal",
    descripcion:
      "Cada producto se trabaja a mano, siguiendo procesos tradicionales y sin atajos.",
  },
  {
    icon: "sparkles",
    titulo: "Ingredientes seleccionados",
    descripcion:
      "Elegimos con cuidado cada ingrediente, porque la calidad empieza en el origen.",
  },
  {
    icon: "sunrise",
    titulo: "Producto elaborado diariamente",
    descripcion:
      "Elaboramos cada día para que cada bocado llegue fresco a tu mesa.",
  },
];
